/** «Контроль → Инкассация»: ответ ручки `/api/control/collection`. */
import { apiFetch, query } from "@/lib/api";
import type { Money } from "@/lib/pnl";

export type CollectionStatus = "found" | "missing" | "no_statement" | "no_account";

export const STATUS_LABEL: Record<CollectionStatus, string> = {
  found: "найдено",
  missing: "не найдено",
  no_statement: "нет выписки",
  no_account: "счёт не задан",
};

export const STATUS_HINT: Record<CollectionStatus, string> = {
  found: "на карте города есть внесение той же суммы рядом по дню",
  missing: "выписки карты загружены, а внесения нет — деньги в банк не пришли",
  no_statement: "выписки карты города не загружены за эти дни — сверить пока не с чем",
  no_account: "куда вносит этот город, не задано",
};

type Counts = { count: number; amount: Money } & {
  [K in `${CollectionStatus}_count`]: number;
} & {
  [K in `${CollectionStatus}_amount`]: Money;
};

export type CollectionAccount = {
  id: number;
  account: string;
  bank_name: string;
  /** До какого дня счёт покрыт выписками; `null` — выписок нет. */
  covered_to: string | null;
};

export type CollectionCity = Counts & { name: string; accounts: CollectionAccount[] };

export type CollectionDeposit = {
  id: number;
  date: string;
  amount: Money;
  account_id: number;
  account: string;
  bank_name: string;
  purpose: string;
};

export type CollectionItem = {
  id: number;
  crm_id: number;
  date: string;
  city: string;
  kassa: string;
  amount: Money;
  comment: string;
  status: CollectionStatus;
  deposits: CollectionDeposit[];
};

export type CollectionReport = {
  date_from: string;
  date_to: string;
  cities: CollectionCity[];
  total: Counts;
  collections: CollectionItem[];
  orphans: CollectionDeposit[];
  orphans_amount: Money;
};

export function loadCollection(filter: { date_from: string; date_to: string }): Promise<CollectionReport> {
  return apiFetch<CollectionReport>(`/api/control/collection${query(filter)}`);
}
